import { styled } from 'styled-system/jsx'

const OfferStack = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
})

const OfferHeading = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '16px',
    fontWeight: '700',
    color: 'quickpass.ink',
  },
})

const OfferDetail = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    color: 'quickpass.ink',
  },
})

const TermsText = styled('p', {
  base: {
    margin: '0',
    fontFamily: 'body',
    fontSize: '13px',
    lineHeight: '1.5',
    color: 'quickpass.inkSoft',
    whiteSpace: 'pre-wrap',
  },
})

const ActionRow = styled('div', {
  base: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px',
  },
})

const SignBox = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    padding: '14px',
    borderRadius: '12px',
    backgroundColor: 'quickpass.primarySoft',
  },
})

const SignLabel = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    fontWeight: '600',
    color: 'quickpass.ink',
  },
})

const SignInput = styled('input', {
  base: {
    width: '100%',
    padding: '10px 12px',
    borderRadius: '10px',
    border: '1px solid #E7E3F1',
    fontFamily: 'body',
    fontSize: '15px',
    color: 'quickpass.ink',
    backgroundColor: 'white',
  },
})

const AgreeText = styled('p', {
  base: {
    margin: '0',
    fontFamily: 'body',
    fontSize: '12px',
    color: 'quickpass.inkSoft',
  },
})

const StatusText = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    fontWeight: '600',
    color: 'quickpass.primary',
  },
})

const ErrorText = styled('p', {
  base: {
    margin: '0',
    fontFamily: 'body',
    fontSize: '13px',
    color: '#B3382C',
  },
})

export {
  OfferStack,
  OfferHeading,
  OfferDetail,
  TermsText,
  ActionRow,
  SignBox,
  SignLabel,
  SignInput,
  AgreeText,
  StatusText,
  ErrorText,
}
